import { useRef, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { parse, stringify } from 'query-string';

export const useQueryParams = <T>(key: string, val?: T): [T, (a: T | ((prev: T) => T)) => void] => {
  const queryString = parse(window.location.search);
  const location = useLocation();
  let defav: any = queryString[key] || val;
  const ref = useRef(defav);
  if (defav ?? false) {
    if (typeof val === 'number') {
      defav = Number(defav) || 0;
    } else if (typeof val === 'boolean') {
      defav = Boolean(defav);
    } else if (Array.isArray(val) && !Array.isArray(defav)) {
      defav = [defav];
    }
  }
  const [, setstate] = useState({});
  const stateCB = useCallback(
    val => {
      const queryString = parse(location.search);
      if (typeof val === 'function') {
        val = val(ref.current);
      }
      queryString[key] = typeof val === 'object' ? Object(val) : val;
      const search = `?${stringify(queryString)}`;
      if (location.search !== search) {
        location.search = search;
        try {
          window.history.replaceState(null, '', location.pathname + search);
        } catch (error) {}
      }
      setstate({});
      ref.current = val;
    },
    [setstate, key, location],
  );
  return [defav as T, stateCB];
};

export default useQueryParams;
